import Color from 'color'
import { ColorSelector } from '../styles/color'
import { AppTheme } from '../styles/theme'

export const isDarkColor = (hexCode: string): boolean => {
    const colorInstance = new Color(hexCode, 'hex')
    return colorInstance.isDark()
}

export const lighten =
    (selector: ColorSelector | string, percent: number) =>
    ({ theme }: { theme: AppTheme }): string => {
        const hexCode = typeof selector === 'function' ? selector({ theme }) : selector
        const color = new Color(hexCode, 'hex')
        return color.mix(Color('white'), percent).hex()
    }

export const opacity = (hexCode: string, percent: number): string => {
    const color = new Color(hexCode, 'hex')
    return `rgba(${color.red()},${color.green()},${color.blue()},${percent})`
}
